export class PaymentRequestsBeneficiaries {
    id: string;
    companyId: string;
    companyName: string;
    dateCreated: number;
    beneficiaryIsInc: boolean;
    beneficiaryComercialName ? : string;
    beneficiaryLegalName ? : string;
    beneficiaryFirstName ? : string;
    beneficiarySecondName ? : string;
    beneficiaryLastName ? : string;
    beneficiarySecondLastName ? : string;
    rfc: string;
    phone: string;
    email: string;
    adress: string;
    city: string;
    state: string;
    zip: string;
    bank: string;
    clabe?: number;
    accountNumber?: string;
    notes: string;
    attachments ? : {
        fileName: string;
    } [];

    constructor(formData ? : any) {
        let data: any = !formData ? {} : formData;

        this.id = data.string || null;
        this.companyId = data.companyId || null;
        this.companyName = data.companyName || null;
        this.dateCreated = data.dateCreated || null;
        this.beneficiaryIsInc = data.beneficiaryIsInc || true;
        this.beneficiaryComercialName = data.beneficiaryComercialName || null;
        this.beneficiaryLegalName = data.legalName || null;
        this.beneficiaryFirstName = data.beneficiaryFirstName || null;
        this.beneficiarySecondName = data.beneficiarySecondName || null;
        this.beneficiaryLastName = data.beneficiaryLastName || null;
        this.beneficiarySecondLastName = data.beneficiarySecondLastName || null;
        this.rfc = data.rfc || null;
        this.phone = data.phone || null;
        this.email = data.email || null;
        this.adress = data.adress || null;
        this.city = data.city || null;
        this.state = data.state || null;
        this.zip = data.zip || null;
        this.bank = data.bank || null;
        this.clabe = data.clabe || null;
        this.accountNumber = data.accountNumber || null;
        this.notes = data.notes || null;
        this.attachments = data.attachments|| [];
    }
}